import { ProcessingLevel } from "@redotech/crdb-enums/fulfillment/processing-level";
import * as z from "zod";
import {
  diffReturnsCenterValues,
  readReturnsCenterSettingPath,
  type ReturnsCenterValues,
} from "./returns-center-setting";

export const RETURN_PROCESSING_LEVEL_PATH =
  "redoManagedReturns.returnProcessingLevel";

/** Admin/CRDB processing level, including receiving. Not the Mongo product enum. */
export const returnProcessingLevelSchema = z.enum(ProcessingLevel);

export function isReturnProcessingLevelPath(path: string): boolean {
  return path === RETURN_PROCESSING_LEVEL_PATH;
}

export function parseReturnProcessingLevelValue(
  value: unknown,
): ProcessingLevel {
  return returnProcessingLevelSchema.parse(value);
}

/** `stored` is the raw CRDB value: saving the default over an unset level is a change, so it gets written. */
export function diffReturnProcessingLevel(
  stored: ProcessingLevel | null,
  next: ProcessingLevel | null | undefined,
): { path: string; prev: ProcessingLevel | null; next: ProcessingLevel }[] {
  if (next == null || stored === next) {
    return [];
  }
  return [{ path: RETURN_PROCESSING_LEVEL_PATH, prev: stored, next }];
}

export const RETURNS_CENTER_PROCESSING_LEVEL_PATH =
  "redoManagedReturns.returnsCenterProcessingLevel";

/** A center's override; null uses the account-wide level. */
export const returnsCenterProcessingLevelsSchema = z.record(
  z.string(),
  returnProcessingLevelSchema.nullable(),
);

export function readReturnsCenterProcessingLevelPath(
  path: string,
): bigint | null {
  return readReturnsCenterSettingPath(
    RETURNS_CENTER_PROCESSING_LEVEL_PATH,
    path,
  );
}

export function isReturnsCenterProcessingLevelPath(path: string): boolean {
  return readReturnsCenterProcessingLevelPath(path) !== null;
}

export function parseReturnsCenterProcessingLevelValue(
  value: unknown,
): ProcessingLevel | null {
  return value == null ? null : returnProcessingLevelSchema.parse(value);
}

export function diffReturnsCenterProcessingLevels(
  stored: ReturnsCenterValues<ProcessingLevel>,
  next: ReturnsCenterValues<ProcessingLevel> | null | undefined,
): {
  path: string;
  prev: ProcessingLevel | null;
  next: ProcessingLevel | null;
}[] {
  return diffReturnsCenterValues(
    RETURNS_CENTER_PROCESSING_LEVEL_PATH,
    stored,
    next,
  );
}
